// Addresses that moved keep working (the Library tab's pages now live under Search, streaks in Social), and a
// creator's short address /@handle opens their profile.
export const redirectPath = (path: string): string =>
  path
    .replace(/(^|\/)library(?=\/)/, '$1search')
    .replace(/(^|\/)streaks(?=$|\?)/, '$1social')
    .replace(/(^|\/)(?:@|%40)([a-z0-9_.]{2,30})(?=$|\?)/i, '$1creator/$2'); // Cloudflare serves /@x as /%40x
